// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"c4070b0f","201":"949e7540","250":"63f230a3","275":"db3639fd","300":"c4d178f0","523":"05260649","790":"9da368f8","829":"41a9ed41","918":"0c258b98","995":"1e8c8c85"}[chunkId] + ".chunk.js";
};